import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FiMenu, FiChevronDown } from "react-icons/fi";
import { MdClose } from "react-icons/md";
import { useInView } from "react-intersection-observer";
import { useAnimation, motion } from "framer-motion";

export const MenuLink = ({ title, children, linkTo }) => {
  const [dropdown, setDropdown] = useState(false);
  return (
    <div
      onMouseEnter={() => setDropdown(true)}
      onMouseLeave={() => setDropdown(false)}
      className="h-5 font-serif"
    >
      <Link to={`/${linkTo ? linkTo : "#"}`}>
        <p className="cursor-pointer hover:underline">{title}</p>
      </Link>
      {dropdown && children}
    </div>
  );
};

const MainMenu = ({ bg }) => {
  const [show, handleShow] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const [showAbout, setShowAbout] = useState(false);
  const [showAcademics, setShowAcademics] = useState(false);
  const [showMore, setShowMore] = useState(false);

  const { ref, inView } = useInView({
    threshold: 0.2,
    triggerOnce: false,
  });

  const animation = useAnimation();

  const variants = {
    visible: { opacity: 1, scale: 1 },
    hidden: {
      opacity: 0,
      scale: 0.1,
      // y: 150,
    },
  };

  const variants2 = {
    visible: { opacity: 1, y: 0 },
    hidden: {
      opacity: 0,
      y: "90vh",
    },
  };

  const variants3 = {
    visible: { opacity: 1, y: 0 },
    hidden: {
      opacity: 0,
      y: 30,
    },
  };

  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 70) {
        handleShow(true);
      } else handleShow(false);
    });
    return () => {
      window.removeEventListener("scroll", () => {
        if (window.scrollY > 100) {
          handleShow(true);
        } else handleShow(false);
      });
    };
    {
      /** */
    }
    if (inView) {
      animation.start({
        opacity: 1,
        scale: 1,
        y: 0,
        // transition: {
        //   type: "spring",
        //   duration: 1,
        //   bounce: 0.3,
        // },
      });
    }
    if (!inView) {
      animation.start({
        opacity: 0,
        scale: 0,
        y: 50,
      });
    }
  }, [inView, animation]);

  return (
    <>
      <div
        className={`flex ${
          show &&
          "bg-gray-900 bg-opacity-95 top-0  transition delay-100 duration-300 ease-in-out"
        } text-white font-semibold justify-between md:justify-around items-center py-6 fixed w-full bg-${bg} z-50 px-4`}
      >
        <Link to="/">
          <h1 className="text-xl md:text-2xl">Main Menu</h1>
        </Link>
        <div className="hidden md:inline-flex gap-x-5 text-lg">
          {/** About */}
          <MenuLink title="About">
            <div className="py-3 absolute top-14">
              <ul className=" bg-white text-black p-4 font-light text-base border rounded-sm">
                <li className="my-1 cursor-pointer pb-2 border-b">
                  <Link to="/about">About Us</Link>
                </li>
                <li className="my-1 cursor-pointer pb-2 border-b">
                  Principal's Desk
                </li>
                <li className="my-1 cursor-pointer pb-2 border-b">
                  <Link to="/missions">Our Mission</Link>
                </li>
              </ul>
            </div>
          </MenuLink>
          <MenuLink title="Academics">
            <div className="py-3 absolute top-14">
              <ul className=" bg-white text-black p-4 font-light text-base border rounded-sm">
                <li className="my-1 cursor-pointer pb-2 border-b">
                  Transfer Certificate
                </li>
                <li className="my-1 cursor-pointer pb-2 border-b">
                  <Link to="/affiliate"> Affiliation</Link>
                </li>
                <li className="my-1 cursor-pointer pb-2 border-b">
                  Examination
                </li>
                <li className="my-1 cursor-pointer pb-2 border-b">
                  Rules & Regulation
                </li>
              </ul>
            </div>
          </MenuLink>
          <MenuLink title="Staff" linkTo="teachers" />
          <MenuLink title="Students" linkTo="student" />
          <MenuLink title="Admissions" />
          <MenuLink title="More">
            <div className="py-3 absolute top-14">
              <ul className=" bg-white text-black p-4 font-light text-base border rounded-sm">
                <li className="my-1 cursor-pointer pb-2 border-b">
                  <Link to="/docs">Important Docs</Link>
                </li>
                <li className="my-1 cursor-pointer pb-2 border-b">
                  <Link to="/calender_holidays">Calender & Holidays</Link>
                </li>
                <li className="my-1 cursor-pointer pb-2 border-b">
                  <Link to="/fees_structure">Fees Structure</Link>
                </li>
              </ul>
            </div>
          </MenuLink>
        </div>
        {/** mobile nav */}
        <FiMenu
          className="text-xl mr-4 md:hidden relative"
          onClick={() => setShowMenu(!showMenu)}
        />
        {showMenu === true && (
          <motion.div
            animate={{ x: 0 }}
            initial={{ x: "100vw" }}
            transition={{
              delay: 0.9,
              // x: { type: "spring", stiffness: 60 },
              duration: 0.7,
            }}
            className="absolute top-0 right-0 bg-blue-900 h-screen w-3/4 p-4"
          >
            <div className="">
              <MdClose onClick={() => setShowMenu(false)} />
            </div>
            <ul
              ref={ref}
              className="pt-10 font-serif font-light flex flex-col gap-y-4"
            >
              <motion.li
                animate={inView ? "visible" : "hidden"}
                variants={variants2}
                transition={{
                  duration: 0.3,
                  ease: "easeIn",
                  type: "spring",
                  stiffness: 30,
                }}
                className="border-b pb-2 border-gray-400 flex justify-between items-center"
              >
                About{" "}
                <FiChevronDown
                  className="text-xl"
                  onClick={() => setShowAbout(!showAbout)}
                />
              </motion.li>
              {showAbout === true && (
                <ul className="pl-4 flex flex-col gap-y-4">
                  <li className="border-b pb-2 border-gray-400">
                    <Link to="/about">About Us</Link>
                  </li>
                  <li className="border-b pb-2 border-gray-400">
                    <Link to="/">Principal's Desk</Link>
                  </li>
                  <li className="border-b pb-2 border-gray-400">
                    <Link to="/missions">Our Missions</Link>
                  </li>
                </ul>
              )}
              <motion.li
                animate={inView ? "visible" : "hidden"}
                variants={variants2}
                transition={{
                  duration: 0.4,
                  ease: "easeIn",
                  delay: 0.2,
                  type: "spring",
                  stiffness: 30,
                }}
                className="border-b pb-2 border-gray-400 flex justify-between items-center"
              >
                Academics
                <FiChevronDown
                  className="text-xl"
                  onClick={() => setShowAcademics(!showAcademics)}
                />
              </motion.li>
              {showAcademics === true && (
                <ul className="pl-4 flex flex-col gap-y-4">
                  <li className="border-b pb-2 border-gray-400">
                    <Link to="/affiliate">Affiliation</Link>
                  </li>
                  <li className="border-b pb-2 border-gray-400">
                    <Link to="/">Transfer Certificate</Link>
                  </li>
                  <li className="border-b pb-2 border-gray-400">
                    <Link to="/">Examination</Link>
                  </li>
                  <li className="border-b pb-2 border-gray-400">
                    <Link to="/">Rules & Regulation</Link>
                  </li>
                </ul>
              )}
              <motion.li
                animate={inView ? "visible" : "hidden"}
                variants={variants2}
                transition={{
                  duration: 0.5,
                  ease: "easeIn",
                  delay: 0.4,
                  type: "spring",
                  stiffness: 30,
                }}
                className="border-b pb-2 border-gray-400"
              >
                <Link to="/teachers">Staff</Link>
              </motion.li>
              <motion.li
                animate={inView ? "visible" : "hidden"}
                variants={variants2}
                transition={{
                  duration: 0.6,
                  ease: "easeIn",
                  delay: 0.6,
                  type: "spring",
                  stiffness: 30,
                }}
                className="border-b pb-2 border-gray-400"
              >
                <Link to="/student">Students</Link>
              </motion.li>
              <motion.li
                animate={inView ? "visible" : "hidden"}
                variants={variants2}
                transition={{
                  duration: 0.7,
                  ease: "easeIn",
                  delay: 0.8,
                  type: "spring",
                  stiffness: 30,
                }}
                className="border-b pb-2 border-gray-400"
              >
                Admissions
              </motion.li>
              <motion.li
                animate={inView ? "visible" : "hidden"}
                variants={variants2}
                transition={{
                  duration: 0.8,
                  ease: "easeIn",
                  delay: 0.9,
                  type: "spring",
                  stiffness: 30,
                }}
                className="border-b pb-2 border-gray-400 flex justify-between items-center"
              >
                More
                <FiChevronDown
                  className="text-xl"
                  onClick={() => setShowMore(!showMore)}
                />
              </motion.li>
              {showMore === true && (
                <ul className="pl-4 flex flex-col gap-y-4">
                  <li className="border-b pb-2 border-gray-400">
                    <Link to="/docs">Important Docs</Link>
                  </li>
                  <li className="border-b pb-2 border-gray-400">
                    <Link to="/calender_holidays">Calender & Holidays</Link>
                  </li>
                  <li className="border-b pb-2 border-gray-400">
                    <Link to="/fees_structure">Fees Structure</Link>
                  </li>
                </ul>
              )}
            </ul>
          </motion.div>
        )}
      </div>
    </>
  );
};

export default MainMenu;
